import React from 'react';
import './error404.scss';
import Header from '../../components/Headers/Header';

function index() {
  return (
    <div>
      <Header />

      <div className="wrapper">
        <section className="error">
          <article className="error_info">
            <p className="error_h2">!ERROR¡</p>
            <p className="error_text">
              Lo sentimos, se presentó un error, es posible que la página que
              estás buscando no exista.
            </p>
            <button className="error_btn">!Vamos de nuevo¡</button>
          </article>
          <figure className="error_fig">
            <img src="/img/e404/error-404.svg" alt="" />
          </figure>
        </section>
      </div>
    </div>
  );
}

export default index;
